<template>
    <router-link to="/nav">
        <div class="menu">
            <h3>
                Меню
            </h3>
        </div>
    </router-link>
</template>

<script>
export default {

}
</script>

<style scoped>

.menu {
    position: fixed;
    margin-top: 5vh;
    margin-left: 91vw;
    background-color: #6c9f67;
    width: 6vw;
    height: 6vw;
    border-radius: 50%;
    display: flex;
    justify-content: center;
    align-items: center;
    transition: all 0.4s ease;
    z-index: 10;
    text-shadow: 1px 1px 2px black, 0 0 1em green, 0 0 0.2em green;
}

.menu:hover {
    transform: scale(1.1);
    transition: all 0.4s ease;
}

h3 {
    color: white;
    text-decoration: none;
    text-transform: uppercase;
    font-size: 1.2vw;
    margin-top: 1.3vh;
}

@media (max-width: 790px) {

    .menu { 
        width: 15vw;
        height: 15vw;
        margin-top: 2vh;
        margin-left: 82vw;
        border: 1px solid white;
    }

    h3 {
        font-size: 12px;
    }

}

</style>